import { vec2 } from "@tlaukkan/tsm";
import { SoundEngine } from "./soundEngine";

export class SoundEffect {
	gain: GainNode;

	protected tracks?: Array<AudioBuffer>;
	protected context: AudioContext;

	protected _volume = 1;
	get volume() { return this._volume; }
	set volume(value: number) {
		this._volume = value;
		this.gain.gain.value = value;
	}

	constructor(protected engine: SoundEngine, protected files: Array<string>, protected output: AudioNode) {
		this.context = this.engine.audioContext;

		// Create gain node
		this.gain = this.context.createGain();
		this.gain.gain.value = 1;
	}

	async init() {
		const loadBuffers = this.files.map(filename => this.loadToBuffer(filename));
		this.tracks = await Promise.all(loadBuffers);
	}

	prepare(loop = false) {
		if (!this.tracks) return;
		const source = this.context.createBufferSource();
		const random = Math.floor(Math.random() * this.tracks.length);
		source.loop = loop;
		source.buffer = this.tracks[random];
		source.connect(this.gain);
		this.gain.connect(this.output);
		return source;
	}

	play() {
		const source = this.prepare();
		if (source) {
			source.start();
		}
	}

	async loadToBuffer(filepath: string) {
		let audioBuffer: AudioBuffer;
		try {
			const u8 = this.engine.audioPack.get(filepath)!;
			const arrayBuffer = u8.slice().buffer;
			audioBuffer = await this.context.decodeAudioData(arrayBuffer);
		}
		catch (e) {
			console.log('Error loading audio file', filepath, e);
			throw e;
		}
		return audioBuffer;
	}
}